<template>
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
        <!-- 顶部导航 -->
        <header class="bg-white dark:bg-gray-800 shadow-md py-4 px-6 sticky top-0 z-10 transition-colors duration-300">
            <div class="container mx-auto flex justify-between items-center">
                <div class="flex items-center space-x-4">
                    <button @click="goBack" class="flex items-center text-reader-text hover:text-primary">
                        <i class="fa fa-arrow-left mr-2"></i>
                        <span class="text-sm">返回</span>
                    </button>
                    <h1 class="text-xl font-bold text-gray-800 dark:text-white">小说详情</h1>
                </div>
            </div>
        </header>

        <!-- 主内容区 -->
        <main class="container mx-auto p-4 md:p-8">
            <!-- 小说介绍区域 -->
            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 md:p-8 mb-8 transition-colors duration-300">
                <div class="flex flex-col md:flex-row items-start md:items-center gap-6"
                    v-if="NovelData">
                    <!-- 小说封面 -->
                    <div class="w-full md:w-1/4 lg:w-1/5">
                        <img
                            :src="NovelData.coverImage"
                            alt="小说封面"
                            class="w-full rounded-lg shadow-lg transform hover:scale-[1.02] transition-transform duration-300"
                        >
                    </div>

                    <!-- 小说信息 -->
                    <div class="flex-grow">
                        <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
                            <div>
                                <h2 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white mb-2">{{ NovelData.title }}</h2>
                                <div class="flex items-center space-x-4 text-sm text-gray-600 dark:text-gray-400 mb-4">
                                    <span><i class="fa fa-book mr-1"></i> 类型: {{ NovelData.type }}</span>
<!--                                    <span><i class="fa fa-file-text-o mr-1"></i> {{ formatWordCount(novel.wordCount) }}</span>-->
                                    <span><i class="fa fa-calendar mr-1"></i> 最后更新: {{ NovelData.updatedAt }}</span>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div v-if="NovelData"
                class="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 md:p-8 mb-8 transition-colors duration-300">
                <!-- 小说简介 -->
                <div class="prose dark:prose-invert prose-sm md:prose-base text-gray-700 dark:text-gray-300">
                    <p>{{ NovelData.description }}</p>
                </div>
            </div>

            <!-- 章节目录 -->
            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 md:p-8 transition-colors duration-300">
                <div class="flex justify-between items-center mb-6">
                    <h3 v-if="ChapterType" class="text-xl font-bold text-gray-800 dark:text-white">{{ChapterType}}</h3>
                    <div class="flex items-center space-x-2">
                        <button
                            @click="toggleOrder"
                            class="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                            title="顺序变换"
                        >
                            <i :class="orderAsc ? 'fa fa-sort-amount-asc' : 'fa fa-sort-amount-desc'"></i>
                        </button>
                        <button
                            @click="toggleViewMode"
                            class="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                            title="切换视图模式"
                        >
                            <i :class="viewMode === 'grid' ? 'fa fa-list' : 'fa fa-th-large'"></i>
                        </button>
                        <button
                            v-show="CreateDraftButton"
                            @click="createChapter"
                            class="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition-colors flex items-center"
                        >
                            <i class="fa fa-plus mr-2"></i>
                            <span>新建章节</span>
                        </button>
                    </div>
                </div>

                <!-- 章节列表 -->
                <div class="chapter-list space-y-3"
                     v-show="isListVisible">
                    <div
                        v-for="chapter in sortedChapters"
                        :key="chapter.id"
                        class="group"
                    >
                        <div
                            class="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer border border-gray-100 dark:border-gray-700 group-hover:border-primary/50"
                        >
                            <div @click="goToChapter(chapter)"
                                class="flex items-center">
                                <span class="text-gray-800 dark:text-white group-hover:text-primary transition-colors">{{ chapter.title }}</span>
                            </div>
                            <div class="flex items-center space-x-3">
                                <span class="text-sm text-gray-500 dark:text-gray-400">{{ chapter.createdAt }}</span>
                                <span class="text-sm text-gray-500 dark:text-gray-400">{{ chapter.wordCount }}字</span>
                                <button @click="DeleteShow(chapter)"
                                    class="text-gray-400 hover:text-primary dark:text-gray-500 dark:hover:text-primary transition-colors opacity-0 group-hover:opacity-100 transition-opacity">
                                    <i class="fa fa-cut"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 草稿箱 -->
                <div class="draft-box space-y-3"
                     v-show="isDraftVisible">
                    <div
                        v-for="draft in sortedDrafts"
                        :key="draft.id"
                        class="group"
                    >
                        <div
                            class="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer border border-gray-100 dark:border-gray-700 group-hover:border-primary/50"
                        >
                            <div @click="goToDraft(draft)"
                                class="flex items-center">
                                <span class="text-gray-800 dark:text-white group-hover:text-primary transition-colors">{{ draft.title }}</span>
                            </div>
                            <div class="flex items-center space-x-3">
                                <span class="text-sm text-gray-500 dark:text-gray-400">{{ draft.createdAt}}</span>
                                <span class="text-sm text-gray-500 dark:text-gray-400">{{ draft.wordCount }}字</span>
                                <button @click="DeleteDraftShow(draft)"
                                        class="text-gray-400 hover:text-primary dark:text-gray-500 dark:hover:text-primary transition-colors opacity-0 group-hover:opacity-100 transition-opacity">
                                    <i class="fa fa-cut"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- 页脚 -->
        <footer class="bg-white dark:bg-gray-800 py-4 px-6 mt-12 transition-colors duration-300">
            <div class="container mx-auto text-center text-sm text-gray-600 dark:text-gray-400">
                <p>© 2025 LiAng个人平台 · 版权归作者所有</p>
            </div>
        </footer>

        <div
            v-if="showAlert"
            class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
        >
            <div class="bg-white rounded-md p-6 w-96">
                <!-- 提示框内的文字内容 -->
                <p class="text-gray-700 mb-6 color-red">
                    确认删除该章节吗？
                </p>

                <!-- 底部的确认和取消按钮 -->
                <div class="flex justify-end space-x-4">
                    <button
                        class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                        @click="DeleteClose"
                    >
                        取消
                    </button>
                    <button
                        class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                        @click="DeleteChapter"
                    >
                        确认
                    </button>
                </div>
            </div>
        </div>
        <div
            v-if="showDraftAlert"
            class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
        >
            <div class="bg-white rounded-md p-6 w-96">
                <!-- 提示框内的文字内容 -->
                <p class="text-gray-700 mb-6 color-red">
                    确认删除该草稿吗？
                </p>

                <!-- 底部的确认和取消按钮 -->
                <div class="flex justify-end space-x-4">
                    <button
                        class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                        @click="DeleteDraftClose"
                    >
                        取消
                    </button>
                    <button
                        class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                        @click="DeleteDraft"
                    >
                        确认
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref, computed, onMounted, watch} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {chapterAndDraftWebSocket} from "@/services/ChapterAndDraftWebSocket";
import {editorChapterStore} from "@/store/editorChapter";
import {editorDraftStore} from "@/store/editorDraft";
import {draftVisionStore} from "@/store/listDraftVisible";
import {storeToRefs} from "pinia";
// 章节传递
const id = ref(null);
const novelId = ref(null);
// 章节传递
const draftId = ref(null);
const draftNovelId = ref(null);

const chapterStore = editorChapterStore()
const draftStore = editorDraftStore()
const visionStore = draftVisionStore()
let {currentVision} = storeToRefs(visionStore);
// 使用计算属性安全获取嵌套值
const isDraftVisible = computed(() => currentVision.value.idv);
const isListVisible = computed(() => currentVision.value.ilv);
const CreateDraftButton = computed(() => currentVision.value.cdv);
const ChapterType = computed(() => currentVision.value.ctp);
const viewMode = computed(() => currentVision.value.vmd);

// 状态管理
const route = useRoute();
const router = useRouter();
const isDarkMode = ref(false);
const showAlert = ref(false);
const showDraftAlert = ref(false);


// 直接获取参数,小说id
const novel_Id = route.params.id;
const { connected, draft_introduce, chapter_introduce,
    novels, loading, error, error2,
    fetchNovelsChapter, CreateDraft,
    DeleteThisDraft, DeleteThisChapter} = chapterAndDraftWebSocket(novel_Id);
const loadData = async () => {
    fetchNovelsChapter(novel_Id);
};

const NovelData = computed(() => {
    const defaultValue = {
        id: '0',
        novelId: '0',
        title: '加载中...',
        description: '加载中…',
        coverImage: '/cover_picture/loading.jpg',
        type:'……',
        updatedAt:'2005-01-25 00:00:00'
    };

    // 合并数据
    return {...defaultValue, ...(novels.value || {})};
});
const DraftList = computed(() => {
    const defaultValue = [
        {
            id: '0',
            novelId: '0',
            title: '加载中...',
            wordCount:'0',
            createdAt:'2005-01-25 00:00:00'
        },
    ];

    // 合并数据
    return {...defaultValue, ...(draft_introduce.value || {})};
});
// 排序相关状态
const orderAsc = ref(true);

// 排序后的章节列表
const sortedChapters = computed(() => {
    if (!chapter_introduce.value || !Array.isArray(chapter_introduce.value)) {
        return [];
    }
    const sorted = [...chapter_introduce.value];
    sorted.sort((a, b) => {
        return orderAsc.value ? a.id - b.id : b.id - a.id;
    });
    return sorted;
});

// 排序后的草稿列表
const sortedDrafts = computed(() => {
    if (!draft_introduce.value || !Array.isArray(draft_introduce.value)) {
        return [];
    }
    const sorted = [...draft_introduce.value];
    sorted.sort((a, b) => {
        return orderAsc.value ? a.id - b.id : b.id - a.id;
    });
    return sorted;
});

// 切换排序顺序
const toggleOrder = () => {
    orderAsc.value = !orderAsc.value;
};

// 切换视图模式
const toggleViewMode = () => {
    if (viewMode.value ==='grid'){
        visionStore.setCurrentVision(false,true,false, '章节目录', 'list')
    }else {
        visionStore.setCurrentVision(true,false,true, '草稿箱', 'grid')
    }
};

// 前往章节编辑页
const goToChapter = (chapter) => {
    chapterStore.setCurrentChapter(chapter.id, chapter.novelId, chapter.title);
    visionStore.setCurrentVision(false,true,false, '章节目录', 'list')
    router.push({ name: 'NovelEditor'});
};
// 前往草稿编辑页
const goToDraft = (chapter) => {
    draftStore.setCurrentChapter(chapter.id, chapter.novelId, chapter.title);
    visionStore.setCurrentVision(true,false,true, '草稿箱', 'grid')
    router.push({ name: 'DraftEditor'});
};

// 创建新章节
const createChapter = () => {
    CreateDraft()
    console.log(DraftList.value)
};
// 导航函数
const goBack = () => {
    router.go(-1)
}
const DeleteShow = (chapter) => {
    id.value = chapter.id;
    novelId.value = chapter.novelId;
    showAlert.value = true;
}
const DeleteClose = () => {
    id.value = 0;
    novelId.value = 0;
    showAlert.value = false;
}
const DeleteChapter = () => {
    DeleteThisChapter(id.value, novelId.value)
    id.value = 0;
    novelId.value = 0;
    showAlert.value = false;
}

const DeleteDraftShow = (draft) => {
    draftId.value = draft.id;
    draftNovelId.value = draft.novelId;
    console.log(draft.id)
    console.log(draft.novelId)
    showDraftAlert.value = true;
}
const DeleteDraftClose = () => {
    draftId.value = 0;
    draftNovelId.value = 0;
    showDraftAlert.value = false;
}
const DeleteDraft = () => {
    DeleteThisDraft(draftId.value, draftNovelId.value)
    showDraftAlert.value = false;
}

// 初始化
onMounted(() => {

    // 检查系统主题偏好
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    isDarkMode.value = prefersDark;
    document.documentElement.classList.toggle('dark', prefersDark);
    // 这里应该根据ID从API获取小说数据
    loadData()
});
</script>

<style scoped>
/* 自定义滚动条 */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: #c5c5c5;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.dark ::-webkit-scrollbar-thumb {
    background: #555;
}

.dark ::-webkit-scrollbar-thumb:hover {
    background: #666;
}

/* 章节目录动画 */
.chapter-item {
    transition: all 0.2s ease;
}
</style>